import { render, staticRenderFns } from "./WelcomeHome.vue?vue&type=template&id=f5db8180&scoped=true"
import script from "./WelcomeHome.vue?vue&type=script&lang=js"
export * from "./WelcomeHome.vue?vue&type=script&lang=js"
import style0 from "./WelcomeHome.vue?vue&type=style&index=0&id=f5db8180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db8180",
  null
  
)

export default component.exports